module.exports = __webpack_public_path__ + "img/r-badge-platinum.e8715aff.png";